<template>
  <div v-show="isActive">
    <div class="loader" :style="`padding: ${loaderPadding} !important;`">
      <svg viewBox="25 25 50 50" class="loader__svg" :style="size">
        <circle cx="50" cy="50" r="20" class="loader__circle" :style="color"></circle>
      </svg>
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  name: 'Loader',
  props: {
    loaderColor: {
      required: false,
      type: String,
      default: '#CCCCCC',
    },
    loaderSize: {
      required: false,
      type: Number,
      default: 50,
    },
    loaderPadding: {
      required: false,
      type: String,
      default: '30px 0',
    },
    isActive: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
  computed: {
    size() {
      return {
        width: `${this.loaderSize}px`,
      };
    },
    color() {
      return {
        stroke: this.loaderColor,
      };
    },
  },
});
</script>

<style lang="scss" scoped>
.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
  &__svg {
    transform-origin: center;
    animation: rotate 2s linear infinite;
  }
  &__circle {
    fill: none;
    stroke-width: 3;
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }
}
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dashoffset: -125px;
  }
}
</style>
